import { useTranslation } from "react-i18next";

import { useCareTabFocusRefresh } from "../hooks/useCareTabFocusRefresh";
import { useTreatmentOverviewByCode } from "../hooks/useTreatmentOverviewByCode";
import type { TreatmentOverview } from "../hooks/useTreatmentOverviews";

import { TreatmentDetailPageView } from "./TreatmentDetailPageView";

type TreatmentDetailContentProps = {
  treatmentCode?: string;
  preloadedTreatment?: TreatmentOverview;
};

export const TreatmentDetailContent = ({
  treatmentCode,
  preloadedTreatment,
}: TreatmentDetailContentProps) => {
  const { ready = true } = useTranslation("care", { useSuspense: false });
  const treatmentQuery = useTreatmentOverviewByCode();
  useCareTabFocusRefresh(treatmentQuery.refetch);

  // Navigation state lets the detail page render immediately while Apollo
  // subscribes to the cached list query. Query data takes precedence so a
  // focus refresh can update the detail UI without a remount.
  const normalizedRouteCode = treatmentCode?.toLowerCase();
  const normalizedPreloadCode =
    preloadedTreatment?.treatmentCode?.toLowerCase();
  const matchingPreloadedTreatment =
    preloadedTreatment &&
    normalizedPreloadCode &&
    normalizedPreloadCode === normalizedRouteCode
      ? preloadedTreatment
      : undefined;
  const treatment =
    treatmentQuery.treatment ??
    (!treatmentQuery.hasData ? matchingPreloadedTreatment : undefined);

  return (
    <TreatmentDetailPageView
      treatment={treatment}
      treatmentCode={treatmentCode}
      translationsReady={ready}
      loading={treatmentQuery.loading}
      error={treatmentQuery.error}
      onRetry={treatmentQuery.refetch}
    />
  );
};
